import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import metadataService from "@/services/metadata/MetadataService.ts";
import {useAuth} from "@/contexts/AuthContext.tsx";

export function useFetchSubCategories(categoryId?: string) {
  const enabled = !!categoryId && categoryId.trim() !== '';

  return useQuery({
    queryKey: ['sub_categories', categoryId],
    queryFn: async () => {
      return await metadataService.fetchSubCategoriesForCategory(categoryId);
    },
    enabled,
  });
}

export function useCreateSubCategory() {
  const qc = useQueryClient();
  const { user } = useAuth();

  return useMutation({
    // Omitting `userId` property from the type as it is being supplied in the service request from the user object from
    // the context. This avoids creating a new duplicate type and the call site of this hook does not need to handler
    // the user context to get the user ID and ensures that the service contract is still upheld.
    mutationFn: async (req: Omit<SubCategoryCreateRequest, 'userId'>) => {
      return await metadataService.createSubCategory({...req, userId: user.id });
    },
    onSuccess: (_data, variables) => {
      qc.invalidateQueries({ queryKey: ['sub_categories', variables.categoryId] });
    },
  });
}
